import { Environment } from 'env';
import { AxiosHttpClient } from 'infrastructure/http';

export const makeAxiosHttpClient = (): AxiosHttpClient => new AxiosHttpClient();
export const makeApiUrl = (path?: string): string =>
  `${Environment.API_URL}${path || ''}`;
